import React from 'react';
import { Helmet } from 'react-helmet-async';

const SuccessStories = () => (
  <div className="container mx-auto px-4 py-12">
    <Helmet>
      <title>Success Stories – MyMoveAdvisor</title>
      <meta name="description" content="Read real success stories from customers who found trusted movers through MyMoveAdvisor and had stress-free moves." />
      <link rel="canonical" href="https://mymoveadvisor.com/success-stories" />
      <meta property="og:title" content="Success Stories – MyMoveAdvisor" />
    </Helmet>
    <h1 className="text-3xl font-bold text-gray-800 mb-4">Success Stories</h1>
    <p className="text-gray-600">Read about successful moves from our customers. (Placeholder)</p>
  </div>
);

export default SuccessStories;
